import React, { useEffect, useState } from 'react'
import { doctors } from '../../Assets/dummyDoc'
import { diagonistics } from '../../Assets/dummyDiagons'
import Header from '../Core/Header'
import { useSelector } from 'react-redux'
import { getAllRequestsfromDoctor, getAllRequestsfromHospital } from '../../service/operations/api_methods'
import { log10 } from 'chart.js/helpers'

const Request = () => {
   const[list1,setList1]=useState(doctors)
    const[list2,setList2]=useState(diagonistics)
  const token=useSelector((state)=>state?.auth?.token)

     const [doctorsList,setDoctorsList]=useState([])
     const[hospitalList,sethospitalList]=useState([])

    const handleDoctorsRequests=async()=>{
        try {
            const res= await getAllRequestsfromDoctor(token)
            console.log(res);
            if(res.status===200){
                setDoctorsList(res.data.data)
            }
            
        } catch (error) {
            console.log(error);
            
        }
    }
      const handleHospitalsRequests=async()=>{
        try {
            const res= await getAllRequestsfromHospital(token)
            console.log(res);
            if(res.status===200){
                sethospitalList(res.data.data)
            }
            
        } catch (error) {
            console.log(error);
            
        }
    }

    useEffect(() => {
      handleDoctorsRequests()
      handleHospitalsRequests()
    }, [])
    
  return (
    <div style={{height:"100vh",width:"100%"}}>
      <Header/>
      <section style={{marginTop:"80px",height:"calc(100vh - 80px)",background: "linear-gradient(180deg, #555454ff, #ffffffff, #5f5f5fff)",padding:"20px"}}>
        <div style={{fontSize:"24px",fontWeight:"700",textAlign:"center",display:"flex",justifyContent:"space-around",padding:"6px"}}>
            <p style={{color:"white"}}>Request of Doctors</p>
            <p style={{color:"white"}}>Request of Diagnostic Center</p>
            </div>
            <div style={{display:"flex",width:'100%'}}>
            <div style={{height:"calc(100vh - 100px)",display:"flex",flexWrap:"wrap",width:"50%",overflowY:"auto",overflowX:"hidden",scrollbarWidth: "none", msOverflowStyle: "none",}}>
            {
            doctorsList.map((item)=>(
                <div style={{width:"20vw",minHeight:"40vh",maxHeight:"fit-content",borderRadius:"10px",padding:"10px",backgroundColor:"#c5c4c4ff",
                    display:"flex",flexDirection:"column",alignItems:"center",margin:"10px",position:"relative"
                }}><p style={{padding:"10px",borderRadius:"5px",backgroundColor:"#042b64ff",color:"white",fontSize:"14px",cursor:"pointer",
                        position:"absolute",right:"30px"
                    }}>
                        Accept</p>
                    <img src='/Assets/about-2.jpg' style={{height:"70%",width:"85%",borderRadius:"10px"}}/>
                    <div style={{display:"flex",flexDirection:"column",alignItems:"start",width:"90%"}}>
                        <p style={{fontSize:"20px",textAlign:"left",fontWeight:"500"}}>{item.name}</p>
                        <p style={{width:"100%",display:"flex",justifyContent:"space-between"}}>
                            <span style={{fontSize:'14px',fontWeight:"700",color:"#d65d3eff"}}>Age:{item.Age}</span>
                            <span style={{fontSize:'14px',fontWeight:"700",color:"#6fa0d8ff"}}>{item.Specialist}</span></p>
                        <p style={{width:"100%",display:"flex",justifyContent:"space-between"}}>
                            <span style={{fontSize:'16px',fontWeight:"700",color:"#a3343aff"}}>Exp:{item.Experience}</span>
                            <span style={{fontSize:'16px',fontWeight:"700",color:"#5456d6ff"}}>Reg:{item.Registered}</span></p>
                        <p style={{fontSize:"14px",fontWeight:"800"}}>Assigned Hospitals</p>
                        <div style={{width:"100%",display:"flex",alignItems:"center",gap:"10px",flexWrap:"wrap"}}>
                            
                            {
                            item.Hospitals.map(i=>
                            <p style={{fontSize:"14px",padding:"3px",borderRadius:"8px",backgroundColor:"#041c3bff",color:"white"}}>{i}</p>)
                        }</div>

                         <div style={{width:"100%",display:"flex",alignItems:"center",gap:"10px",flexWrap:"wrap"}}>
                            <p style={{fontSize:"14px",fontWeight:"800"}}>Assigned Diagonistic center</p><br/>
                            {
                            item.Diagonistics.map(i=>
                            <p style={{fontSize:"14px",padding:"3px",borderRadius:"8px",backgroundColor:"#053d2cff",color:"#fcfcfcff"}}>{i}</p>)
                        }</div>
                     </div>

                    </div>
            ))
            }

        </div>
        
           <div style={{height:"calc(100vh - 100px)",display:"flex",flexWrap:"wrap",width:"50%",overflowY:"auto",overflowX:"hidden",scrollbarWidth: "none", msOverflowStyle: "none",}}>
            {
            hospitalList.map((item)=>(
                <div style={{width:"20vw",minHeight:"40vh",maxHeight:"fit-content",borderRadius:"10px",padding:"10px",backgroundColor:"#c5c4c4ff",
                    display:"flex",flexDirection:"column",alignItems:"center",margin:"10px",position:"relative"
                }}>
                    <p style={{padding:"10px",borderRadius:"5px",backgroundColor:"#042b64ff",color:"white",fontSize:"14px",cursor:"pointer",
                        position:"absolute",right:"30px"
                    }}>
                        Accept</p>
                    <img src='/Assets/diagonasitic.jpg' style={{height:"70%",width:"85%",borderRadius:"10px"}}/>
                    <div style={{display:"flex",flexDirection:"column",alignItems:"start",width:"90%"}}>
                        <p style={{fontSize:"20px",textAlign:"left",fontWeight:"500"}}>{item.name}</p>
                        <p style={{width:"100%",display:"flex",justifyContent:"space-between"}}>
                            <span style={{fontSize:'14px',fontWeight:"700",color:"#d65d3eff"}}>Patients:{item.Patients}+</span>
                            <span style={{fontSize:'14px',fontWeight:"700",color:"#6fa0d8ff"}}>reg:{item.Registered}</span></p>
                        <p style={{width:"100%",display:"flex",justifyContent:"space-between"}}>
                            <span style={{fontSize:'16px',fontWeight:"700",color:"#a3343aff"}}>{item.Address}</span></p>
                           
                        <p style={{fontSize:"14px",fontWeight:"800"}}>Medical Test provided</p>
                        <div style={{width:"100%",display:"flex",alignItems:"center",gap:"10px",flexWrap:"wrap"}}>
                            
                            {
                            item.TestProvided.map(i=>
                            <p style={{fontSize:"12px",padding:"3px",borderRadius:"8px",backgroundColor:"#041c3bff",color:"white"}}>{i}</p>)
                        }</div>
                            <p style={{fontSize:"14px",fontWeight:"800"}}>Assigned Hospital</p>
                         <div style={{width:"100%",display:"flex",alignItems:"center",gap:"10px",flexWrap:"wrap"}}>
                            
                            {
                            item.Doctors.map(i=>
                            <p style={{fontSize:"12px",padding:"3px",borderRadius:"8px",backgroundColor:"#053d2cff",color:"#fcfcfcff"}}>{i}</p>)
                        }</div>
                     </div>

                    </div>
            ))
            }

        </div>

            </div>
      </section>
    </div>
  )
}

export default Request
